// Exporting default configuration object
export default {
  clientID: "", // Placeholder for client ID
};

// Function to check and return layout name based on input value
export const checkLayoutName = (value) => {
  let valueFinal = "admin"; // Default layout is "admin"

  // Check for specific roles and assign corresponding layout
  if (value === "SuperAdmin") {
    valueFinal = "admin"; // SuperAdmin maps to admin layout
  }
  if (value === "Ag") {
    valueFinal = "admin"; // Ag maps to admin layout
  }
  if (value === "Mg") {
    valueFinal = "manager"; // Mg maps to manager layout
  }
  if (value === "Sub-Mg") {
    valueFinal = "manager"; // Sub-Mg maps to manager layout
  }

  return valueFinal; // Return the final layout name
};
